const colors = {
    white: '#FFFFFF',
    blue: '#1435c3',
    light: '#F8F9FA',
    lightblue: '#5fe7ff',
    dark: '#333',
    success: '#53C305',
    successBg: '#F4FFF2',
    success500: '#30CD60',
    error: '#EB2101',
    error500: '#DA4343',
    errorBg: '#FFF2F2',
    neutral: '#848788',
    placeholder: '#A7ABC3',
    border: '#E4E5F0',
    background: '#F6F6F6',
    warning: '#F78212',
    warningBg: '#FCF8E3',
    link: '#047FFF',
    link500: '#1990FF',
    linkBg: '#F0F7FF',
    disable: '#D2D2D2',
    sunYellow: '#FFD125',
    text: '#434657',
    red: '#ef2741',
    black: '#000000',
    gray50: '#FAFAFA',
    gray100: '#F5F5F5',
    gray130: '#82869E',
    gray200: '#EEEEEE',
    gray300: '#E0E0E0',
    gray400: '#BDBDBD',
    gray500: '#9E9E9E',
    gray600: '#757575',
    gray700: '#616161',
    gray800: '#424242',
    gray900: '#212121',
    green50: '#E8F5E9',
    green100: '#C8E6C9',
    green200: '#A5D6A7',
    green300: '#81C784',
    green400: '#66BB6A',
    green500: '#4CAF50',
    green600: '#43A047',
    green700: '#388E3C',
    green800: '#2E7D32',
    green900: '#1B5E20',
    blue50: '#E3F2FD',
    blue100: '#BBDEFB',
    blue200: '#90CAF9',
    blue300: '#64B5F6',
    blue400: '#42A5F5',
    blue500: '#2196F3',
    blue600: '#1E88E5',
    blue700: '#1976D2',
    blue800: '#1565C0',
    blue900: '#0D47A1',
    linear: '',
};
const theme = {
    brand: {
        primary: colors.blue,
        secondary: colors.lightblue,
        tertiary: '#E6EEFF',
        background: '#f1f0f1',
        loading: colors.blue,
        linear: '',
    },
    colors,
    breakpoints: ['576px', '768px', '1024px'],
    borderRadius: '8px',
};

export { theme as t };
